var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0 ma-0 mobile-page",class:_vm.classProps},[_c('v-subheader',{staticClass:"primary--text pa-0 ma-0 h-auto mb-1 text-capitalize",class:_vm.labelCls},[_vm._v(_vm._s(_vm.label))]),_vm._t("input")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }